import { Controller } from "@hotwired/stimulus"

// Three-state recalculate button: "Recalculate" → spinner → "Recalculated" → back to "Recalculate"
//
// Usage:
//   <form data-controller="recalculate-button">
//     <button type="submit" data-recalculate-button-target="button">Recalculate</button>
//   </form>
export default class extends Controller {
  static targets = ["button"]

  connect() {
    this.element.addEventListener("turbo:submit-start", this.onStart)
    this.element.addEventListener("turbo:submit-end", this.onEnd)
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-start", this.onStart)
    this.element.removeEventListener("turbo:submit-end", this.onEnd)
    clearTimeout(this.resetTimer)
  }

  onStart = () => {
    if (!this.hasButtonTarget) return
    this.buttonTarget.disabled = true
    this.buttonTarget.innerHTML = `
      <svg class="animate-spin h-3.5 w-3.5 inline-block mr-1" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
    `
  }

  onEnd = () => {
    if (!this.hasButtonTarget) return
    this.buttonTarget.disabled = false
    this.buttonTarget.innerHTML = `
      <svg class="h-3.5 w-3.5 inline-block mr-1 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
      </svg>Recalculated
    `
    this.buttonTarget.classList.add("text-green-600")
    this.buttonTarget.classList.remove("text-gray-500", "hover:text-sapphire")

    this.resetTimer = setTimeout(() => this.reset(), 3000)
  }

  reset() {
    if (!this.hasButtonTarget) return
    this.buttonTarget.innerHTML = `
      <svg class="h-3.5 w-3.5 inline-block mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
      </svg>Recalculate
    `
    this.buttonTarget.classList.remove("text-green-600")
    this.buttonTarget.classList.add("text-gray-500", "hover:text-sapphire")
  }
}
